import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Button, Modal } from 'antd';

import Type1Box from '../type1box';
import Type2Box from '../type2box';
import { restApi } from '../../../apis';
//----------------------------------------------------------------------------------------------------

const SequenceDetailModal = (props) => {
  const setGModal = props.setGModal;
  const setLoading = props.setLoading;
  const setSorts = props.setSorts;
  const [open, setOpen] = useState(false);

  const [data, setData] = useState(null);

  const sequenceId = props.sequenceId;

  const showModal = () => {
    setOpen(true);
  };

  //----------------------------------------------------------------------------------------------------
  useEffect(() => {
    // 로딩
    setLoading(true);
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    (async (args) => {
      const params = {};
      const response = await restApi.get(`/sequence/${sequenceId}`, {
        params,
      });
      const payload = response?.data?.payload;
      // console.log('--->', payload);
      if (payload) {
        setData(payload.sequence);
      }
      setLoading(false);
    })();
  }, []);

  return (
    <div style={{ ...styles.container }}>
      {/*---------------------------------------------------------------------------------------------------- */}
      <div
        style={{
          ...styles.row,
          borderTop: '1px solid #4B4B4B',
          marginTop: '5.1rem',
        }}
      >
        <div
          style={{ ...styles.col, width: '20%', justifyContent: 'flex-start' }}
        >{`시퀀스명`}</div>
        <div
          style={{ ...styles.col, width: '80%', justifyContent: 'flex-end' }}
        >
          {data && data.name}
        </div>
      </div>

      <div style={{ ...styles.row }}>
        <div
          style={{ ...styles.col, width: '20%', justifyContent: 'flex-start' }}
        >{`총시간`}</div>
        <div
          style={{ ...styles.col, width: '80%', justifyContent: 'flex-end' }}
        >
          {data && data.totalTime}
        </div>
      </div>

      <div style={{ ...styles.row }}>
        <div
          style={{ ...styles.col, width: '20%', justifyContent: 'flex-start' }}
        >{`운동강도`}</div>
        <div
          style={{ ...styles.col, width: '80%', justifyContent: 'flex-end' }}
        >
          {data && data.intensity}
        </div>
      </div>

      <div style={{ ...styles.row, borderBottom: '1px solid #4B4B4B' }}>
        <div
          style={{ ...styles.col, width: '20%', justifyContent: 'flex-start' }}
        >{`생성자`}</div>
        <div
          style={{ ...styles.col, width: '80%', justifyContent: 'flex-end' }}
        >
          {data && data.centerName}
        </div>
      </div>
      {/*---------------------------------------------------------------------------------------------------- */}
      <div style={{ ...styles.body }}>
        {data &&
          data.rounds &&
          data.rounds.map((item) => {
            if (item.type == 1) {
              return <Type1Box data={item} {...props} />;
            } else if (item.type == 2) {
              return <Type2Box data={item} {...props} />;
            }
            return <></>;
          })}
      </div>
      {/*---------------------------------------------------------------------------------------------------- */}
      <div
        style={{
          ...styles.footer,
          borderTop: '1px solid #4B4B4B',
          paddingTop: 20,
        }}
      >
        <Button
          width={69}
          onClick={(e) => {
            showModal(true);
          }}
          danger
        >{`삭제`}</Button>
        <Button
          idth={69}
          style={{
            marginLeft: '1rem',
            background: '#7367F0',
            color: '#FFF',
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
            borderRadius: 6,
          }}
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
          }}
        >
          {`닫기`}
        </Button>
      </div>
      <Modal
        title={
          <div
          // style={{
          //   background: 'rgba(168, 170, 174, 0.16)',
          // }}
          >
            알림
          </div>
        }
        open={open}
        centered
        closable={false} // Whether a close (x) button is visible on top right of the modal dialog or not
        footer={[
          <Button
            key="delete"
            type="primary"
            // loading={loading}
            onClick={async (e) => {
              //삭제
              await restApi.delete(`/admin/sequence/${sequenceId}`);

              setSorts((prev) => {
                return {
                  ...prev,
                  reload: new Date(),
                };
              });

              setOpen(false);
              setGModal((prev) => {
                return {
                  ...prev,
                  show: false,
                };
              });
            }}
            danger
          >
            {`삭제`}
          </Button>,
          <Button
            key="cancel"
            type="default"
            onClick={(e) => {
              setOpen(false);
            }}
          >
            {`취소`}
          </Button>,
        ]}
      >
        <p>
          해당 시퀀스는 밸런스피터 데이터베이스와 생성자 디바이스 모두에서
          삭제됩니다. 또한, 데이터베이스에서 한번 삭제한 시퀀스는 다시 복구할 수
          없습니다. 정말 해당 시퀀스를 삭제하시겠습니까?
        </p>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '59.3rem',
    height: '90rem',
    // height: '102.3rem',
    flexDirection: 'column',
    // justifyContents: 'space-between',
    // justifyContent: 'center',
    background: '#FFFFFF',
    boxshadow: '0px 5px 20px rgba(75, 70, 92, 0.4)',
    borderRadius: 6,
    paddingLeft: '3rem',
    paddingRight: '3rem',
  },
  row: {
    display: 'flex',
    width: '100%',
    height: '5.4rem',
    justifyContent: 'space-between',
    padding: 0,
    borderBottom: '1px solid rgba(0, 0, 0, 0.07)',
  },

  body: {
    display: 'flex',
    // borderBottom: '1px solid #4B4B4B',
    flexDirection: 'column',
    height: 660,
    padding: 2,
    overflow: 'auto',
  },
  col: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footer: {
    marginTop: '2rem',
    marginBottom: '3rem',
    display: 'flex',
    // height: '8rem',
    flexDirection: 'row',
    justifyContent: 'center',
  },
};
export default SequenceDetailModal;
